import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import AxiosController from "@/api/axiosController";
const axiosController = new AxiosController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }

  @setLoadingState
  async getAuOwners({ commit }, params = {}) {
    const resp = await axiosController.getAuOwners(params);
    commit("setAuOwners", resp);
  }
}
export default (new Actions).asPlainObject();